// Reads a configuration value that webpack would otherwise freeze into the
// bundle at build time.
//
// config/webpack/base.js registers `new webpack.EnvironmentPlugin(process.env)`,
// which replaces every `process.env.SOME_KEY` reference with a string literal
// during compilation. That is correct where one image serves one environment —
// but the containerised image is built once and then promoted across
// environments, so the literal is whatever the BUILD environment held, not what
// the environment actually serving the page holds. A per-instance environment
// therefore ran with another environment's LaunchDarkly client, Firebase
// project, reCAPTCHA site key and Google API keys, silently and with no way to
// override them.
//
// Rails re-supplies the same keys at request time on `window.__RUNTIME_ENV__`
// (see RuntimeConfigHelper), emitted ahead of the pack tags so it exists before
// any bundle executes.

// The baked values, named one by one on purpose.
//
// EnvironmentPlugin is a thin wrapper over DefinePlugin, which rewrites only
// *static* `process.env.KEY` member expressions. A computed `process.env[key]`
// is a different AST node: it survives the build untouched and then resolves at
// runtime against the empty `process.env` object that
// node-polyfill-webpack-plugin supplies to the browser — so it is always
// `undefined`, and a lookup table built that way would silently return nothing
// rather than the compile-time value. Each key has to be spelled out to be
// inlined.
//
// A key absent from the build environment is simply left as a runtime lookup
// and evaluates to `undefined`, which is the intended "no baked value" answer.
//
// Keep this list in sync with RuntimeConfigHelper::PACK_RUNTIME_ENV_KEYS.
const BAKED_ENV = {
  CANNY_APP_ID: process.env.CANNY_APP_ID,
  FIREBASE_FUNCTION_REGION: process.env.FIREBASE_FUNCTION_REGION,
  FIREBASE_PROJECT: process.env.FIREBASE_PROJECT,
  FIRESTORE_DOMAIN: process.env.FIRESTORE_DOMAIN,
  FIRESTORE_PROCESSED_MEDIA: process.env.FIRESTORE_PROCESSED_MEDIA,
  GOOGLE_GEOCODING_API_KEY: process.env.GOOGLE_GEOCODING_API_KEY,
  GOOGLE_MAPS_API_KEY: process.env.GOOGLE_MAPS_API_KEY,
  GOOGLE_STREET_VIEW_API_KEY: process.env.GOOGLE_STREET_VIEW_API_KEY,
  LAUNCHDARKLY_CLIENT_ID: process.env.LAUNCHDARKLY_CLIENT_ID,
  MAX_VIDEO_UPLOAD_SIZE_MB: process.env.MAX_VIDEO_UPLOAD_SIZE_MB,
  PROTOCOL: process.env.PROTOCOL,
  RAILS_ENV: process.env.RAILS_ENV,
  RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY
}

// The baked value stays as the fallback deliberately: where the global is
// absent — a Sprockets-only page, a unit test, a Heroku slug built and run from
// the same config — behaviour is exactly what it was before.
export function runtimeEnv(key) {
  const config = typeof window !== 'undefined' ? window.__RUNTIME_ENV__ : null
  const value = config ? config[key] : undefined

  // Empty string counts as absent: the helper omits blank values, but a stale
  // or hand-edited global should fall through rather than blank out a key.
  if (value === undefined || value === null || value === '') {
    return BAKED_ENV[key]
  }

  return value
}

export default runtimeEnv
